import { TAGS, api } from "../../api.ts"
import type { IJailApiResponse } from "./jail.types"

export const jailApi = api.enhanceEndpoints({
  addTagTypes: [TAGS.JAIL, TAGS.USER]
})

export const jailEndpoints = jailApi.injectEndpoints({
  endpoints: (builder) => ({
    getMyJailStatus: builder.query<IJailApiResponse, void>({
      query: () => ({
        url: "/jail/my-status",
        method: "GET"
      }),
      providesTags: () => [{ type: TAGS.JAIL, id: "my-status" }]
    }),
    startCorrectionalWork: builder.mutation<any, void>({
      query: () => ({
        url: "/jail/correctional-work/start",
        method: "POST"
      }),
      invalidatesTags: () => [{ type: TAGS.JAIL, id: "my-status" }]
    }),
    payBuyout: builder.mutation<any, void>({
      query: () => ({
        url: "/jail/buyout",
        method: "POST"
      }),
      invalidatesTags: () => [
        { type: TAGS.JAIL, id: "my-status" },
        { type: TAGS.USER, id: "me" }
      ]
    })
  })
})

export const {
  useGetMyJailStatusQuery,
  useStartCorrectionalWorkMutation,
  usePayBuyoutMutation,
  endpoints: { getMyJailStatus }
} = jailEndpoints
